"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "turmoil" };
const _hoisted_2 = { class: "events-board" };
const _hoisted_3 = { class: "turmoil-board" };
const _hoisted_4 = { class: "turmoil-header" };
const _hoisted_5 = { class: "turmoil-lobby" };
const _hoisted_6 = { class: "dominant-party-name" };
const _hoisted_7 = { class: "dominant-party-bonus" };
const _hoisted_8 = { class: "policy-user-cubes" };
const _hoisted_9 = { class: "chairman-spot" };
const _hoisted_10 = { class: "turmoil-reserve" };
const _hoisted_11 = { class: "policies" };
const _hoisted_12 = { class: "policies-title" };
const _hoisted_13 = { class: "policies-global" };
const _hoisted_14 = { class: "party-bonus" };
const _hoisted_15 = { class: "grid-leaders" };
const _hoisted_16 = { class: "delegate-spot" };
const _hoisted_17 = { class: "grid-parties" };
const _hoisted_18 = { class: "grid-delegates" };
const _hoisted_19 = { class: "party-bonus" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_global_event = (0, vue_1.resolveComponent)("global-event");
    const _component_turmoil_agenda = (0, vue_1.resolveComponent)("turmoil-agenda");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (_ctx.turmoil.distant)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_global_event, {
                    key: 0,
                    globalEventName: _ctx.turmoil.distant,
                    type: "distant",
                    showDistance: true
                }, null, 8, ["globalEventName"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.turmoil.coming)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_global_event, {
                    key: 1,
                    globalEventName: _ctx.turmoil.coming,
                    type: "coming",
                    showDistance: true
                }, null, 8, ["globalEventName"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.turmoil.current)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_global_event, {
                    key: 2,
                    globalEventName: _ctx.turmoil.current,
                    type: "current",
                    showDistance: true
                }, null, 8, ["globalEventName"]))
                : (0, vue_1.createCommentVNode)("", true)
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                (0, vue_1.createElementVNode)("div", _hoisted_5, [
                    ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(5, (n) => {
                        return (0, vue_1.createElementVNode)("div", {
                            class: "lobby-spot",
                            key: n
                        }, [
                            (_ctx.turmoil.lobby.length >= n)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, vue_1.normalizeClass)('player-token ' + _ctx.turmoil.lobby[n - 1])
                                }, null, 2))
                                : (0, vue_1.createCommentVNode)("", true)
                        ]);
                    }), 64))
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_6, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: (0, vue_1.normalizeClass)('party-name party-name--' + _ctx.partyNameToCss(_ctx.turmoil.ruling))
                    }, [
                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.turmoil.ruling), 1)
                    ], 2)), [
                        [_directive_i18n]
                    ])
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_7, [
                    (0, vue_1.createVNode)(_component_turmoil_agenda, {
                        id: _ctx.getPolicy(_ctx.turmoil.ruling)
                    }, null, 8, ["id"])
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_8, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.turmoil.policyActionUsers, (n) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, [
                            (n.turmoilPolicyActionUsed)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: n.color,
                                    class: (0, vue_1.normalizeClass)('policy-use-marker board-cube--' + n.color)
                                }, null, 2))
                                : (0, vue_1.createCommentVNode)("", true),
                            (n.politicalAgendasActionUsedCount > 0)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: n.color,
                                    class: (0, vue_1.normalizeClass)('policy-use-marker board-cube--' + n.color)
                                }, (0, vue_1.toDisplayString)(n.politicalAgendasActionUsedCount), 3))
                                : (0, vue_1.createCommentVNode)("", true)
                        ], 64));
                    }), 256))
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_9, [
                    (_ctx.turmoil.chairman)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 0,
                            class: (0, vue_1.normalizeClass)('player-token ' + _ctx.turmoil.chairman)
                        }, null, 2))
                        : (0, vue_1.createCommentVNode)("", true)
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_10, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.turmoil.reserve.length, (n) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "lobby-spot",
                            key: n
                        }, [
                            (_ctx.turmoil.reserve.length >= n)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, vue_1.normalizeClass)('player-token ' + _ctx.turmoil.reserve[n - 1].color)
                                }, (0, vue_1.toDisplayString)(_ctx.turmoil.reserve[n - 1].number), 3))
                                : (0, vue_1.createCommentVNode)("", true)
                        ]));
                    }), 128))
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_11, [
                    (0, vue_1.createElementVNode)("div", _hoisted_12, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                            class: "policies-clickable",
                            href: "#",
                            onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)(($event) => (_ctx.toggleMe()), ["prevent"]))
                        }, [...(_cache[1] || (_cache[1] = [
                                (0, vue_1.createTextVNode)("Policies", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                    ]),
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", _hoisted_13, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.turmoil.parties, (party) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: party.name,
                                class: "policy-block"
                            }, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    class: (0, vue_1.normalizeClass)('party-name party-name--' + _ctx.partyNameToCss(party.name))
                                }, [
                                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(party.name), 1)
                                ], 2)), [
                                    [_directive_i18n]
                                ]),
                                (0, vue_1.createElementVNode)("div", _hoisted_14, [
                                    (0, vue_1.createVNode)(_component_turmoil_agenda, {
                                        id: _ctx.getPolicy(party.name)
                                    }, null, 8, ["id"])
                                ])
                            ]));
                        }), 128))
                    ], 512), [
                        [vue_1.vShow, _ctx.isVisible()]
                    ])
                ])
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_15, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.turmoil.parties, (party) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: party.name,
                        class: (0, vue_1.normalizeClass)(['leader-spot', 'leader-spot--' + _ctx.partyNameToCss(party.name), { 'player-token-new-leader': (party.name === _ctx.turmoil.dominant) }])
                    }, [
                        (0, vue_1.createElementVNode)("div", _hoisted_16, [
                            (party.partyLeader)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, vue_1.normalizeClass)(['player-token', party.partyLeader])
                                }, null, 2))
                                : (0, vue_1.createCommentVNode)("", true)
                        ])
                    ], 2));
                }), 128))
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_17, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.turmoil.parties, (party) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: party.name,
                        class: (0, vue_1.normalizeClass)('board-party board-party--' + _ctx.partyNameToCss(party.name))
                    }, [
                        (0, vue_1.createElementVNode)("div", _hoisted_18, [
                            ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(6, (n) => {
                                return (0, vue_1.createElementVNode)("div", {
                                    class: "delegate-spot",
                                    key: n
                                }, [
                                    (party.delegates.length >= n)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                            key: 0,
                                            class: (0, vue_1.normalizeClass)('player-token ' + party.delegates[n - 1].color)
                                        }, (0, vue_1.toDisplayString)(party.delegates[n - 1].number), 3))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ]);
                            }), 64))
                        ]),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: (0, vue_1.normalizeClass)('party-name party-name--' + _ctx.partyNameToCss(party.name))
                        }, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(party.name), 1)
                        ], 2)), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createElementVNode)("div", _hoisted_19, [
                            (0, vue_1.createVNode)(_component_turmoil_agenda, {
                                type: "party-bonus",
                                id: _ctx.getBonus(party.name)
                            }, null, 8, ["id"])
                        ])
                    ], 2));
                }), 128))
            ]),
            _cache[2] || (_cache[2] = (0, vue_1.createStaticVNode)("<div class=\"turmoil-party-transition-arrow-grid\"><div class=\"turmoil-party-transition-arrow\"></div><div class=\"turmoil-party-transition-arrow\"></div><div class=\"turmoil-party-transition-arrow\"></div><div class=\"turmoil-party-transition-arrow\"></div><div class=\"turmoil-party-transition-arrow\"></div></div>", 1))
        ])
    ])), [
        [_directive_trim_whitespace]
    ]);
}
